module.exports = __webpack_public_path__ + "static/img/no_img.3a914171.png";